export class DisproveAccuracy100 {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get comparer() {
        return this.parent;
    }
    get isCorrectStringStillPossible() {
        return this.comparer.compareIncludes.doesExpectIncludeInput;
    }
    get disproveCertainty() {
        if (this.isCorrectStringStillPossible)
            return 0;
        if (!this.comparer.compareEqual.isEqual)
            return 100;
        return 100;
    }
}
